import http from './http';

export default {
  createGoogleCalendarIntegration(data) {
    return http().post(`/v1/google_integrations/calendar`, data);
  },
  createGmailIntegration(data) {
    return http().post(`/v1/google_integrations/gmail`, data);
  },
  getOauthUrl(id) {
    return http().get(`/v1/google_integrations/oauth_url/${id}`);
  }
}
